<template>
  <b-navbar id="navbar" class="nav-bar-container" toggleable="lg" type="dark" variant="info" sticky>
    <link itemprop="url" rel="stylesheet" href="css/english.css" v-if="!showEnglish"/>
    <b-container>
        <b-navbar-brand href="#" :style="'background-image:url(' + 'images/homepage/' + logo +')'"><span>NavBar</span></b-navbar-brand>
        <b-navbar-toggle target="nav-collapse" id="mynavtoggle">
        </b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item to="/">
              الرئيسية
            </b-nav-item>
            <!-- <b-nav-item :to="{ name: 'programs'}">
              البرامج
            </b-nav-item>showEnglish -->
            <b-nav-item :to="currentPath['programs']">
              البرامج
            </b-nav-item>
            <b-nav-item href="http://hotels.agazabook.com/" target="_blank">
              الفنادق
            </b-nav-item>
            <b-nav-item href="http://flights.agazabook.com/" target="_blank">
              طيران
            </b-nav-item>
            <b-nav-item :to="currentPath['restaurants']">
              المطاعم
            </b-nav-item>
            <b-nav-item :to="currentPath['shopping']">
              تسويق وترفيه
            </b-nav-item>
            <b-nav-item  :to="currentPath['transportation']">
              النقل السياحي
            </b-nav-item>
            <b-nav-item :to="currentPath['places']">
              المزارات
            </b-nav-item>
            <b-nav-item :to="currentPath['partners']">
              شركاؤنا
            </b-nav-item>
            <b-nav-item :to="currentPath['blog']">
              الإتيكيت
            </b-nav-item>
            <b-nav-item href="#">اخر الاخبار</b-nav-item>
            <!-- <b-nav-item href="#">اتصل بنا</b-nav-item> -->
            <template>
              <b-nav-item @click="changeLang('ar')" v-if="!showEnglish">
                عربي
              </b-nav-item>
              <b-nav-item @click="changeLang('en')"  v-if="showEnglish">
                EN
              </b-nav-item>
            </template>
          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <!-- <b-navbar-nav class="ml-auto">
            <b-nav-item-dropdown text="Lang" right>
              <b-dropdown-item href="#">EN</b-dropdown-item>
              <b-dropdown-item href="#">ES</b-dropdown-item>
              <b-dropdown-item href="#">RU</b-dropdown-item>
              <b-dropdown-item href="#">FA</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav> -->
        </b-collapse>
      </b-container>
   </b-navbar>
</template>
<script type="text/javascript">
import {EnPath, ArPath} from './functions.js'
export default {
  name:'Nav',
  data() {
    return {
      showEnglish:null,
      logo: 'logo-main.png',
      currentPath:''
    }
  },
  methods: {
    changeLang(value) {
      localStorage.setItem('lang', value);
      // this.$router.push({ name: 'home' })
      if(localStorage.getItem('lang') == 'ar') {
        this.showEnglish = true
      } else if (localStorage.getItem('lang') == 'en') {
        this.showEnglish = false
      }
      // this.$router.go()
      // this.$router.push(this.$route.path)

    },
    scrollToTop() {
         window.scrollTo(0,0);
    },

    //get Pathes
    changePath() {
      if(this.showEnglish) {
        this.currentPath = ArPath
      } else {
        this.currentPath = EnPath
      }
      var cuurent = this.$route.name
      this.$router.push(this.currentPath[cuurent])
    }
  },
  watch: {
    'showEnglish': function() {
      this.changePath()
    }
  },
  mounted() {
    if(localStorage.getItem('lang') == 'ar') {
      this.showEnglish = true
    } else if (localStorage.getItem('lang') == 'en') {
      this.showEnglish = false
    }
    var vm = this;
    //change background color while scroll
    this.$nextTick(function(){
      window.addEventListener("scroll", function(){
        var navbar = document.getElementById("navbar");
        var nav_classes = navbar.classList;
        var x = document.getElementById("mynavtoggle");
        if(document.documentElement.scrollTop >= 150) {
          if (nav_classes.contains("shrink") === false) {
            nav_classes.toggle("shrink");
            vm.logo = 'logo-white.png'
            x.classList.toggle('white')
          }
        }
        else {
          if (nav_classes.contains("shrink") === true) {
            vm.logo = 'logo-main.png'
            nav_classes.toggle("shrink");
            x.classList.toggle('white')
          }
        }
      })
    });

    //change to current path
    this.changePath()


  }

}
</script>
<style media="screen">
.shrink .navbar-dark .navbar-toggler {
color: red!important;
}
</style>
